'use client';

import Content from '~/shared/components/content/content';
import FooterCopy from '~/shared/components/footer/components/footer-copy';
import FooterLegalLinks from '~/shared/components/footer/components/footer-legal-links';
import FooterMenu from '~/shared/components/footer/components/footer-menu';
import ScrollToTop from '~/shared/components/footer/components/scroll-to-top';
import type { Locale } from '~/shared/constants';

import './footer.scss';

type FooterProps = Readonly<{
  lng: Locale;
  isAdminPanel?: boolean;
  isPlatform?: boolean;
}>;

const Footer = ({ lng }: FooterProps) => {
  return (
    <footer itemScope itemType="https://schema.org/WPFooter" className="footer">
      <Content className="footer__wrapper">
        <FooterMenu lng={lng} />
        <FooterLegalLinks lng={lng} />
      </Content>
      <ScrollToTop />
      <FooterCopy />
    </footer>
  );
};

export default Footer;
